import React from 'react';
import './placeholder.scss';

const index = ({text, src, alt}) => {
  return (
    <div className="container-placeholder-component">
      <div className="container-placeholder-component-wrapper">
        <img src={src} alt={alt} />
        <p className="container-placeholder-component-title">{text}</p>
      </div>
    </div>
  );
};

export default index;
